<template>
    <div class="row">
        <div class="col-6 my-auto">
            <div class="mb-3">
                <label for="inputTextName" class="form-label size-14 fw-400">SKU de producto</label>
                <div class="form-control rounder-8 bgc-secondary-60 py-3">{{this.propHead.row.product_name}}</div>
            </div>
            <div class="d-flex gap-2">
                <div class="mb-3 w-100">
                    <label for="inputTextName" class="form-label size-14 fw-400">Convertir a</label>
                    <select name="store" class="form-select size-14 py-3 px-3 rounder-8" v-model="data.convert">
                        <option :value="null">No convertir</option>
                        <option :value="'UNIDAD'">Unidad</option>
                        <option :value="'CAJA'">Caja</option>
                        <option :value="'SUMAR'">Sumar</option>
                        <option :value="'RESTAR'">Restar</option>
                    </select>
                </div>
                <div class="mb-3 w-100">
                    <label for="inputTextName" class="form-label size-14 fw-400">Unidades</label>
                    <input type="text" class="form-control border border-1 rounder-8"  
                            v-model="data.unit_convert" placeholder="Ingresar la cantidad de unidades">
                    <div
                        v-if="errors.errors.unit_convert"
                        id="productHelp"
                        class="form-text text-danger"
                        >
                        {{errors.message}}
                    </div>
                </div>
            </div>
            <div class="mb-3 mt-2">
                <button
                    type="button"
                    class="btn bg-dark text-white rounder-8 size-16 fw-600 px-5 py-3 w-100"
                    @click="send()">
                    Guardar
                </button>
            </div>
        </div>
        
        <div class="col-6 text-center my-auto">
            <img src="/images/forms/image_five.png" alt="image de formulario 1" class="w-100">
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "product-store-config",
    props: {
        propHead: {
            required: true,
        },
    },
    data() {
        return {
            data: {
                client_competitor: [],
                rule: 0,
                value: 0.00,
                router_file: '',
                product: null,
                convert: null,
                unit_convert: null,
                business: null
            },
            errors: {
                message: null,
                errors: {},
            },
        }
    },
    computed: {
        ...mapGetters(["authentication_user"]),
    },
    created(){
        this.getData()
    },
    methods:{
        ...mapActions(["update", "executeCommit"]),
        /**
         * Initialize form data if editing an existing policy (update mode).
         * Sets form fields from propHead.row if action is 'Actualiza'.
         * @return {void}
         */
        getData() {
            if (this.propHead.action == 'Actualiza') {
                this.data = {
                    client_competitor: this.propHead.row.client_competitor,
                    rule: this.propHead.row.rule,
                    value: this.propHead.row.value,
                    unit_convert: this.propHead.row.unit_convert,
                    convert: (this.propHead.row.convert === '' || this.propHead.row.convert === undefined) ? null : this.propHead.row.convert
                }
            }
        },
        /**
         * Validate and dispatch the correct action based on the form mode.
         * Calls actualizate depending on propHead.action.
         * @return {void}
         */
        send(){
            if (this.propHead.action == 'Actualiza') {
                this.actualizate()
            }
        },
        /**
         * Update an existing policy by sending form data to the API.
         * - On success: shows notification and closes the form
         * - On error: displays validation errors
         * @return {void}
         */
        actualizate(){
            this.data.id = this.propHead.row.id
            this.data.product = this.propHead.row.product
            this.data.value = this.data.rule == 1 ? 0 : this.data.value
            //Validate convert field
            const allowed = [null, 'UNIDAD', 'CAJA', 'SUMAR']
            this.data.convert = allowed.includes(this.data.convert)? this.data.convert : null
            this.data.business = this.authentication_user.client_business_select ? this.authentication_user.client_business_select : null;
            this.update({
                url: `/api/pricescrapingrules/update_policies/`,
                params: this.data
            }).then(() => {
                this.$notification.success(
                    "Política de precios actualizada correctamente.",
                    { timer: 10, showCloseIcn: true }
                );
                this.close('actualizate');
            })
            .catch((error) => {
                if (error.status == 400) {
                    this.errors = error.data;
                }
            });
        },
        /**
         * Close the modal and emit a refresh event to parent.
         * @return {void}
         */
        close(action) {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.$emit("refrest", action);
        },
    }
};
</script>
